module.exports = __webpack_public_path__ + "img/truss-types.920be508.png";